// Presentation helpers for test results. Pure, so they can be tested without
// rendering anything.

export function formatPercent(value, digits = 0) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '—';
  return `${Number(value).toFixed(digits)}%`;
}

export function formatScore(value) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '—';
  return Number.isInteger(Number(value)) ? String(value) : Number(value).toFixed(1);
}

const STATUS_LABELS = {
  completed: 'Completed',
  in_progress: 'In progress',
  not_started: 'Not taken',
};

export function resultStatusLabel(status) {
  return STATUS_LABELS[status] || 'Unknown';
}

export function resultStatusClass(status) {
  if (status === 'completed') return 'status';
  if (status === 'in_progress') return 'pending';
  return 'status draft';
}

/** How to colour an accuracy figure: good above 70%, poor below 40%. */
export function accuracyTone(accuracy) {
  if (accuracy === null || accuracy === undefined) return 'none';
  if (accuracy >= 0.7) return 'good';
  if (accuracy < 0.4) return 'poor';
  return 'mixed';
}

/** The questions the batch found hardest, worst first. Unanswered ones are excluded. */
export function hardestQuestions(questions, limit = 3) {
  return (questions || [])
    .filter((q) => q.accuracy !== null && q.accuracy !== undefined)
    .sort((a, b) => a.accuracy - b.accuracy)
    .slice(0, limit);
}

function csvCell(value) {
  const text = value === null || value === undefined ? '' : String(value);
  return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/** A CSV of the student rows, for the institute's own records. */
export function resultsToCsv(results) {
  const header = ['Student', 'Email', 'Status', 'Score', 'Attempts', 'Completed at'];
  const rows = (results?.students || []).map((s) => [
    s.userName,
    s.userEmail,
    resultStatusLabel(s.status),
    s.score ?? '',
    s.attemptCount ?? 0,
    s.completedAt ? new Date(s.completedAt).toISOString() : '',
  ]);
  return [header, ...rows].map((r) => r.map(csvCell).join(',')).join('\n');
}

export function downloadTextFile(filename, text, type = 'text/csv') {
  const blob = new Blob([text], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
